import { NavLink, Outlet } from "react-router-dom";
import "./adminLayout.scss";

const adminLinks = [
  { label: "Dashboard", to: "/admin/dashboard" },
  { label: "Channel Outflows", to: "/admin/expenses" },
  { label: "Blogs", to: "/admin/blogs" },
  { label: "Coupons", to: "/admin/coupons" },
  { label: "Itinerary", to: "/admin/itinerary" },
  { label: "Destinations", to: "/admin/destinations" },
  { label: "Legal", to: "/admin/legal" },
  { label: "Messages", to: "/admin/messages" },
  { label: "Road Notes", to: "/admin/road-notes" },
  { label: "Products", to: "/admin/products" },
  { label: "Stock Manager", to: "/admin/stock-manager" },
  { label: "Orders", to: "/admin/orders" },
  { label: "Donations", to: "/admin/donation" },
  { label: "QR Stats", to: "/admin/qr-stats" },
  { label: "gallery", to: "/admin/gallery" },
  { label: "Videos", to: "/admin/videos" },
  { label: "Milestones", to: "/admin/milestones" },
  { label: "Settings", to: "/admin/settings" },
  { label: "Profile", to: "/admin/profile" },
];

export default function AdminLayout() {
  return (
    <main className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar__brand">
          <h2>Mini Miles</h2>
          <span>Admin Dashboard</span>
        </div>
        <nav className="admin-nav">
          {adminLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                isActive ? "admin-nav__link active" : "admin-nav__link"
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* 🟢 CLEANED UP: Hardcoded topbar box deleted so sub-components inject their headers */}
      <section className="admin-main">
        <Outlet />
      </section>
    </main>
  );
}
